import { useQueryClient } from "@tanstack/react-query";

import { T } from "@repo/transifex";
import { useCurrentSession } from "~/api/sessions/hooks/use-session";
import { sessionsKeys } from "~/api/sessions/keys";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { tillsKeys } from "~/api/tills/keys";
import { ScreenIssue } from "~/components/screen/screen-issue";
import { logger } from "~/services/logger";
import { NetworkStatus } from "~/components/network-status/network-status";

export const InvalidSessionScreen = () => {
  const { data: till, fetchStatus: tillStatus } = useCurrentTill();
  const { data: session, fetchStatus: sessionStatus } = useCurrentSession();

  const queryClient = useQueryClient();

  const isInvalid = till?.sessionId && !session?.isValid;

  return (
    <ScreenIssue>
      <ScreenIssue.Title>
        {isInvalid ? (
          <T _str="Till session is invalid" />
        ) : (
          <T _str="Till is getting ready" />
        )}
      </ScreenIssue.Title>

      <ScreenIssue.Text>
        <T _str="Please tap try again or ask staff for help" />
      </ScreenIssue.Text>

      <ScreenIssue.Button
        onClick={() => {
          logger.warn(
            `User manually refreshed cache - ${
              isInvalid ? "till session invalid" : "till session missing"
            }`,
            {
              till_id: till?.id ?? "unknown",
              session_id: session?.id ?? "unknown"
            }
          );
          queryClient.invalidateQueries({
            queryKey: tillsKeys.detail(till?.id ?? "unknown")
          });
          queryClient.invalidateQueries({
            queryKey: sessionsKeys.detail({
              tillId: till?.id ?? "unknown",
              sessionId: session?.id ?? "unknown"
            })
          });
        }}
        loading={tillStatus === "fetching" || sessionStatus === "fetching"}
      >
        <T _str="Try again" />
      </ScreenIssue.Button>

      <NetworkStatus />
    </ScreenIssue>
  );
};
